export const HOST = " https://us-central1-impactcar-iccmtl.cloudfunctions.net/api"
// export const HOST = 'http://localhost:7000/api/v1'
export const USER_APP_DATA_KEY = 'userAppData'
